var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('Header',{attrs:{"member":_vm.member,"logo":"logo_info","defaultActive":_vm.defaultActive}}),_c('router-view'),(!_vm.showFoot)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }